import { createEventTracker } from '../util';
import { DXCardEngagement } from './types';

export const trackDXCardEngagement = createEventTracker<DXCardEngagement>('DX Card Engagement');
